
import Moderator from '@/models/bread/Moderator/tuitionPlayer'


export default {
    key: 'TuitionPlayer',
    name: {
        singular: 'Player',
        plural: 'Players',
    },
    parents: [
        'Tuition',
    ],
    Admin: false,
    Moderator: Moderator,
    Teacher: false,
}